export { default as cr } from './cr.png'
export { default as bofa } from './bofa.png'
export { default as vt } from './vt.png'
export { default as ct } from './ct.png'
export { default as nf } from './nf.png'
export { default as jt } from './jt.png'
export { default as jarvis } from './jarvis.png'
export { default as itsa } from './itsa.png'




// WEBPACK FOOTER //
// ./src/layouts/images/projects/index.js